import trans from './translations.json';

export default (text, language) => {
  if (trans[text] && trans[text][language]) {
    return trans[text][language];
  }
  return text;
};
